<template>
  <section v-if="show" :class="{loading:loading}" class="mb-4 mt-3 dashboard-locations">
    <i v-if="loading" class="fas fa-circle-notch text-primary fa-spin loading-icon"></i>
    <div class="content">
      <div class="d-block d-lg-none mb-3 pl-2">
        <i :class="[isLocked ?  'fas fa-lock' : 'fas fa-lock-open']" class="fa-lg text-primary cursor-pointer"
           :title="[isLocked ?  'Unlock to reorder locations' : 'Lock reordering on locations']"
           @click="isLocked = !isLocked"
           v-if="selected !== 'all' && locations.length"
        >
        </i>
      </div>
      <div class="d-flex pb-1 px-0 bg-light head">
        <p class="col-2 col-lg-1 m-0 font-weight-bold" v-if="selected === 'all'">Day</p>
        <p class="col-2 col-lg-1 m-0 pl-2 font-weight-bold">Stop #</p>
        <p class="col-4 m-0 font-weight-bold">Company Name</p>
        <p class="col-4 m-0 font-weight-bold">Address</p>
        <div class="col-3 pr-2 d-lg-flex justify-content-end d-none">
          <i :class="[isLocked ?  'fas fa-lock' : 'fas fa-lock-open']" class="fa-lg text-primary cursor-pointer"
             :title="[isLocked ?  'Unlock to reorder locations' : 'Lock reordering on locations']"
             @click="isLocked = !isLocked"
             v-if="selected !== 'all' && locations.length"
          >
          </i>
        </div>
      </div>
      <draggable v-if="locations.length" :sort="isSortable" :list="locations" itemKey="id" :delay="50" class="list-group" @change="changed">
        <template #item="{element, index}">
          <li draggable="false" @click="rowClicked(element)" :key="element.value" :class="{unlocked:!isLocked}" class="list-group-item px-2">
            <div class="row row-content position-relative">
              <div v-if="selected === 'all'" class="col-2 col-lg-1 font-size-small lh-small text-muted">{{getDay(element.location_visit_on_day)}}</div>
              <div class="col-2 col-lg-1 font-size-small lh-small font-weight-bold">{{getStopNumber(element, index)}}</div>
              <div class="col-4 font-size-small lh-small">{{element.company_name}}</div>
              <div class="col col-lg-4 font-size-small lh-small">{{element.address}}</div>
              <div class="col d-flex justify-content-end action-indicator">
                <i v-if="element.hasAction" title="This location has incomplete actions" class="fas fa-exclamation-triangle fa-lg text-primary pr-2"></i>
              </div>
            </div>
          </li>
        </template>
      </draggable>
      <p class="mt-2 ml-3" v-else>There are no routes for this selected time period.</p>
    </div>
  </section>
</template>

<script>
  import draggable from 'vuedraggable'

  export default {
    data() {
      return {
        isLocked: true,
        locationForm: this.$inertia.form({
          locations: this.locations
        }),
      }
    },
    mounted() {
      this.setIndexesForAll()

      this.hasActions()
    },
    updated() {
      this.setIndexesForAll()
    },
    components: {
      draggable
    },
    props: {
      locations: Array,
      loading: Boolean,
      selected: String,
      users: Array,
      show: Boolean
    },
    computed: {
      isSortable() {
        return this.selected === 'all' ? false : !this.isLocked
      }
    },
    methods: {
      changed() {
        this.locations.forEach((elem, index) => elem.location_visit_order = index)
        this.$inertia.post(route('mtd.locationsaveorder'), {locations: JSON.stringify(this.locations)}, {
          preserveScroll: true 
        })
      },
      getDay(location) {
        return['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][location] || 'None'
      },
      hasActions() {
        this.locations.forEach(location => {
        this.users.forEach(user => {
          if (location.id === user.location_id) {
            if(user.actions.length) location.hasAction = true
          }
        })
      })
      },
      getStopNumber(elem, index) {
        if (this.selected === 'all') {
          return elem.location_visit_on_day === null ? '' : elem.location_visit_order 
        } else return index+1
      },
      rowClicked(elem) {
        this.$emit('rowClicked', elem.id)
      },
      setIndexesForAll() {
        let counter = 0
        let currentDay = 0
        this.locations.forEach(elem => {
          if (currentDay !== elem.location_visit_on_day) counter = 0
          currentDay = elem.location_visit_on_day
          counter++
          elem.location_visit_order = counter
        })
      }
    },
    watch: {
      locations() {
        this.hasActions()
      }
    }
  }
</script>
